(function ($) {
  $(function () {
    $(document).ready(function () {
      //graphic-parallax
      $(window).on("load resize scroll", function () {
        var $windowWidth = $(window).width();
        if ($windowWidth > 991) {
          var parallaxElement = $(".graphic-parallax"),
            parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function () {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                'will-change': "transform",
                'transform': "translate3d(0," + scrolled * -0.15 + "px, 0)"
              });
            }
          });
        }
      });
      //quote-parallax
      $(window).on("load resize scroll", function () {
        var $windowWidth = $(window).width();
        if ($windowWidth > 991) {
          var parallaxElement = $(".quote-parallax"),
            parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function () {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                'will-change': "transform",
                'transform': "translate3d(0," + scrolled * -0.15 + "px, 0)"
              });
            }
          });
        }
      });
      //quote-parallax-opposite direction
      $(window).on("load resize scroll", function () {
        var $windowWidth = $(window).width();
        if ($windowWidth > 991) {
          var parallaxElement = $(".quote-parallax-opposite"),
            parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function () {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                'will-change': "transform",
                'transform': "translate3d(0," + scrolled * 0.15 + "px, 0)"
              });
            }
          });
        }
      });
      //cta-parallax
      $(window).on("load resize scroll", function () {
        var $windowWidth = $(window).width();
        if ($windowWidth > 991) {
          var parallaxElement = $(".cta-parallax"),
            parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function () {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                'will-change': "transform",
                'transform': "translate3d(0," + scrolled * -0.15 + "px, 0)"
              });
            }
          });
        }
      });
      //cta-parallax-opposite direction
      $(window).on("load resize scroll", function () {
        var $windowWidth = $(window).width();
        if ($windowWidth > 991) {
          var parallaxElement = $(".cta-parallax-opposite"),
            parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function () {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                'will-change': "transform",
                'transform': "translate3d(0," + scrolled * 0.15 + "px, 0)"
              });
            }
          });
        }
      });

    });

  });
})(jQuery);



